import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * Sometimes, request-based operations have multiple responses. For example, a
 * `getPosts` operation might emit `success` when the initial posts are loaded,
 * and then subsequent `success` when new posts are posted
 *
 * This is mainly used to distinguish between an initial {@link Phase.Response}
 * and subsequent {@link Phase.FollowUp}
 */
export enum Phase {
  /**
   * Corresponds to the `request` status
   */
  Request = 'request',
  /**
   * Corresponds to the first emission of a response status for a given
   * request
   */
  Response = 'response',
  /**
   * Corresponds to every emission of a response status after the first for a
   * given request
   */
  FollowUp = 'follow-up',
}
// Needs to be before namespace is defined
const PHASES: ReadonlySet<Phase> = new Set(Object.values(Phase) as Phase[])
export namespace Phase {
  export const ALL: readonly Phase[] = Array.from(PHASES)
  export const isPhase = TypeChecker.Factory.oneOf(PHASES)
  export const assertIsPhase: TypeAsserter<Phase> =
    TypeAsserter.Factory.from(isPhase)
}
